import * as React from "react";
import type { SVGProps } from "react";
const SvgMountainsSlope = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g fill="currentColor" clipPath="url(#mountains-slope_svg__a)">
      <path d="M21 21H3c-.34 0-.65-.17-.84-.45a.98.98 0 0 1-.08-.95L6.7 8.98c.39-.91 1.16-1.48 2.05-1.52.55-.01 1.04.15 1.46.48l1.22-2.53C11.85 4.53 12.7 4 13.55 4c.89.01 1.7.59 2.1 1.5l6.26 14.1c.14.31.11.67-.08.95-.18.28-.5.46-.84.46zM4.53 19h14.94L13.83 6.31c-.1-.23-.23-.31-.3-.31-.1 0-.21.11-.29.28l-1.96 4.06c-.16.34-.5.56-.87.57-.38 0-.72-.19-.9-.52l-.37-.68c-.08-.15-.18-.25-.28-.24-.08 0-.21.09-.3.31z" />
      <path d="M17.56 21c-.55 0-1-.45-1-1 0-1.03-2.72-1.5-4.53-1.81-2.33-.41-4.35-.76-4.35-2.41 0-1.32 1.54-1.57 3.68-1.92l.83-.14c-.38-.1-.81-.2-1.22-.26a.996.996 0 0 1-.83-1.14.99.99 0 0 1 1.14-.83c2.71.42 4.09 1.24 4.09 2.43 0 1.32-1.54 1.57-3.68 1.92-.21.04-.47.08-.73.12.47.1.99.19 1.41.26 2.75.48 6.18 1.08 6.18 3.79 0 .55-.45 1-1 1z" />
    </g>
    <defs>
      <clipPath id="mountains-slope_svg__a">
        <path fill="#fff" d="M2 4h20v17H2z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgMountainsSlope;
